import React, { useState, useEffect } from "react";
import _ from "lodash";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Modal, Row, Col } from "react-bootstrap";
import "../../pages/_Components/ReactBeautifulDnd.css";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import SwalMessage from "../_Components/SwalMessage";
import ApiAmusementGroup from "../../../core/api/api.amusementGroup";
import ApiAmusementService from "../../../core/api/api.amusementService";
import SelectComponent from "../_Components/ReactSelectComponent";
import ApiRegion from "../../../core/api/api.region";

const ChangeOrderAmusementGroup = ({ showModalAmusementGroupOrder, setShowModalAmusementGroupOrder }) => {
  const [AmusementGroups, setAmusementGroups] = useState([]);
  const [amusementServiceId, setAmusementServiceId] = useState(null);
  const [services, setServices] = useState([]);
  const [formInputs, setFormInputs] = useState({});
  const [allAmusementCityList, setAllAmusementCityList] = useState([]);
  const selectStyles = {
    menu: (base) => ({
      ...base,
      zIndex: 10000,
    }),
  };

  const [selectedCity, setSelectedCity] = useState(null);

  const getAmusemntServices = async (selectedCity) => {
    try {
      const response = await ApiAmusementGroup.getAllAmusementGroupsAndComplex({ regionId: selectedCity?.value });
      setAmusementGroups(response);
    } catch (error) {
    }
  };
  const inputChangeHandlerCity = (selectedOption) => {
    setSelectedCity(selectedOption);
    getAmusemntServices(selectedOption);
  };

  // Fetch all services
  useEffect(() => {
    const fetchGroups = async () => {
      try {
        const amusementGroups = await ApiAmusementGroup.getAllAmusementGroupsAndComplex({ regionId: null });
        setAmusementGroups(amusementGroups);

        const response = await ApiRegion.getAllCity();
        setAllAmusementCityList(response);
      } catch (error) {
      }
    };

    fetchGroups();
  }, []);
  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const updatedAmusementGroups = Array.from(AmusementGroups);
    const [reorderedItem] = updatedAmusementGroups.splice(result.source.index, 1);
    updatedAmusementGroups.splice(result.destination.index, 0, reorderedItem);
    setAmusementGroups(updatedAmusementGroups);
  };
  const handleClose = () => {
    setShowModalAmusementGroupOrder(false);
  };
  const sendSortedAmusementGroups = async () => {
    try {
      // اطلاعات مورد نیاز برای ارسال به سرور
      const dataToSend = {
        AmusementGroups: AmusementGroups.map((item) => ({ id: item.id, title: item.title, type: item.type })),
        regionId: selectedCity.value,
      };
      // ارسال درخواست به سرور
      const response = await ApiAmusementGroup.changeOrderAmusementGroup(dataToSend);
      SwalMessage({ title: response.message, iSsuccess: true });
      //setShowModalAmusementGroupOrder(false);
    } catch (error) {
    }
  };
  ///
  const handleServiceChange = (selectedOption) => {
    setAmusementServiceId(selectedOption?.value);
    inputChangeHandler2(selectedOption);
  };
  const inputChangeHandler2 = async (selectedOption) => {
    const { type, value } = selectedOption;

    setFormInputs((prevState) => ({
      ...prevState,
      [type]: selectedOption,
    }));

    try {
      const amusementGroups = await ApiAmusementGroup.getAllGroups(value);
      if (amusementGroups) {
        setAmusementGroups(amusementGroups);
      }
    } catch (error) {
    }
  };
  return (
    <div>
      <div className="card-body pt-3 pb-0">
        {/* Start Modal */}
        <Modal centered size="md" show={showModalAmusementGroupOrder} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>ترتیب قرارگیری دسته های تفریحات</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col xs="12" className="mb-2">
                <SelectComponent
                  className=" mt-2"
                  placeholder="انتخاب شهر"
                  options={allAmusementCityList?.map((item) => ({
                    value: item.id,
                    label: item.id + "-" + item.name,
                  }))}
                  value={selectedCity}
                  onChange={inputChangeHandlerCity}
                />
              </Col>
            </Row>
            <DragDropContext onDragEnd={handleDragEnd}>
              <Droppable droppableId="droppable">
                {(provided) => (
                  <ul className="sortable-list" {...provided.droppableProps} ref={provided.innerRef}>
                    {AmusementGroups.map((item, index) => (
                      <Draggable key={index} draggableId={index.toString()} index={index}>
                        {(provided) => (
                          <li
                            className="sortable-item"
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <span>{item.title}</span>
                          </li>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </ul>
                )}
              </Droppable>
            </DragDropContext>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" disabled={!selectedCity} onClick={sendSortedAmusementGroups}>
              <SaveIcon /> ذخیره
            </Button>
            <Button variant="danger" onClick={handleClose}>
              <CloseIcon /> بستن
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};
export default ChangeOrderAmusementGroup;
